import React, { PureComponent, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./index.css";
import api from "../../Services/api";
import { FcSearch } from "react-icons/fc";
import { FaEraser } from "react-icons/fa";
import Loading from '../../components/Loading';
import ModalPrincipal from '../../components/ModalAlert/modal'

export class Child extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      offset: 0,
      tableData: [],
      orgtableData: [],
      perPage: 7,
      currentPage: 0,
      pagAtual: 1,
      length: 0,
      endpoint: this.props.endPoint,
      clicked: false,
      atualiza: 0,
      search: '',
      isChecked: [],
      consult: this.props.consult,
      forcePage: 0
    };

    this.handlePageClick = this.handlePageClick.bind(this);
  }



  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        pagAtual: selectedPage + 1,
        forcePage: selectedPage
      },
      () => {
        this.loadMoreData();
      }
    );


  };

  loadMoreData() {

    const data = this.state.orgtableData;

    const slice = data.slice(
      this.state.offset,
      this.state.offset + this.state.perPage,

    );

    //////////////////////aqui
    this.setState({
      pageCount: Math.ceil(data.length / this.state.perPage),
      tableData: slice,
      length: data.length,
    });

  }


  handlePageClick_clear = () => {
    const selectedPage = 0;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        pagAtual: selectedPage + 1,
        forcePage: selectedPage,
      },
      () => {
        this.loadMoreData();
      }
    );
  };

  handleInputChange = (event) => {
    this.setState({ search: event.target.value });
  };

  do_search = () => {
    //------------------------------BUSCAR

    if (this.state.search === '' || this.state.search === undefined || this.state.search === null) {
     
    } else {
  

      const temp_rows = this.state.orgtableData.filter(
        (e) => {

          return (
            JSON.stringify(e)
              .toLowerCase()
              .indexOf(this.state.search.toLowerCase()) >= 0
          );

        }

      );

      var slice = temp_rows.slice(
        this.state.offset,
        this.state.offset + this.state.perPage
      );

      this.setState({
        pageCount: Math.ceil(temp_rows.length / this.state.perPage),
        orgtableData: temp_rows,
        tableData: slice,
        length: temp_rows.length,
        pagAtual: 0,
      });

      this.handlePageClick_clear()
    }


  };

  clear_search = () => {
    //------------------------------LIMPAR
    this.setState({ search: '' });

    var slice = this.state.dataT.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );

    this.setState({
      pageCount: Math.ceil(this.state.dataT.length / this.state.perPage),
      orgtableData: this.state.dataT,
      tableData: slice,
      length: this.state.dataT.length,
      pagAtual: 0,
      forcePage: 0,
    });

    this.handlePageClick_clear();

  };

  componentDidMount() {
    this.getData();
    //this.clear_search();
  }

  getData() {


      try {
        api.get(this.props.endPoint, {
          params: {
            id: this.props.id
          }
        }).then((res) => {

          if (res.data.status === 200) {

            var data = res.data.data.map((element) => { return { ok: 0, ...element } });


            var slice = data.slice(
              this.state.offset,
              this.state.offset + this.state.perPage
            );

            this.setState({
              pageCount: Math.ceil(data.length / this.state.perPage),
              orgtableData: data,
              tableData: slice,
              dataT: data,
              length: data.length,
            });
        
            this.setState({ isLoading: false });

          }else{
            
            var data = []
            var slice = data.slice(
              this.state.offset,
              this.state.offset + this.state.perPage
            );

            this.setState({
              pageCount: Math.ceil(data.length / this.state.perPage),
              orgtableData: data,
              tableData: slice,
              dataT: data,
              length: data.length,
            });
            
            this.setState({ isLoading: false });
          }



        });


      }
      catch (e) { 

            
        this.setState({ isLoading: false });
        var data = []
        var slice = data.slice(
          this.state.offset,
          this.state.offset + this.state.perPage
        );

        this.setState({
          pageCount: Math.ceil(data.length / this.state.perPage),
          orgtableData: data,
          tableData: slice,
          dataT: data,
          length: data.length,
        });
       
      }
    

  }


  getDataatualizar(teste) {
    var data = teste;
    var slice = data.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );

    this.setState({
      pageCount: Math.ceil(data.length / this.state.perPage),
      orgtableData: teste,
      tableData: slice,
      dataT: teste,
      length: data.length,
    });
  }


  toggle = (index) => {
    if (this.state.clicked === index) {
      //if clicked question is already active, then close it
      return this.setState({ clicked: null });
    }
    this.setState({ clicked: index });
  };


  handlecheckbox = (e, i, id) => {

    const { value, checked } = e.target;

    if (checked) {

      this.setState({
        isChecked: ([...this.state.isChecked, value])
      });

  

      return 1;
      
    } else {

      this.setState({
        isChecked: (this.state.isChecked.filter((e) => e !== value))
      });


      return 0;

    } 

  }

  IncluirRelacionamento = () => {

    const temp_rows = this.state.dataT.filter(
      (e) => {
        return e.ok === 1
      }
    );
;
  }

  formatHoraBrasil = (horaString) => {
    if (!horaString) return "";
  
    // Espera formato HH:mm
    if (!/^\d{2}:\d{2}$/.test(horaString)) {
      return horaString;
    }
  
    let [hora, minuto] = horaString.split(":").map(Number);
  
    // 🔽 subtrai 3 horas
    hora = hora - 3;
  
    // Ajuste para virar o dia (ex: 02:00 - 3 = 23:00)
    if (hora < 0) {
      hora += 24;
    }
  
    return `${String(hora).padStart(2, "0")}:${String(minuto).padStart(2, "0")}`;
  };
  
  
  render() {
   return (
  <div className="grid-container">

    {this.state.pageCount > 0 && (
      <div className="grid-table-wrapper">

        <table className="grid-table">
          <thead>
            <tr className="grid-header">
              <th className="grid-th">Data inicial</th>
              <th className="grid-th">Hora inicial</th>
              <th className="grid-th">Situação</th>
              <th className="grid-th">Situação alterada por</th>
              <th className="grid-th">Módulo</th>
            </tr>
          </thead>

          <tbody>
            {this.state.tableData.map((tdata, i) => (
              <tr className="grid-row" key={Object.values(tdata)[1]}>
                <td className="grid-td">{Object.values(tdata)[2]}</td>
                <td className="grid-td">
                  {this.formatHoraBrasil(Object.values(tdata)[3])}
                </td>
                <td className="grid-td-description">{Object.values(tdata)[4]}</td>
                <td className="grid-td">{Object.values(tdata)[9]}</td>
                <td className="grid-td">{Object.values(tdata)[8]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    <div className="grid-pagination-container">

      <div className="grid-pagination-content">

        {(this.state.pageCount === 0 || this.state.pageCount === null) && (
          <div className="grid-empty">
            <h2>Nenhum resultado encontrado.</h2>
            <h2>Página 1 de 1</h2>
          </div>
        )}

        <div className="grid-pagination">

          {this.state.pageCount > 0 && (
            <div className="grid-page-info">
              <h2>
                Página {this.state.pagAtual} de {this.state.pageCount}
              </h2>
            </div>
          )}

          {this.state.pageCount > 1 && (
            <ReactPaginate
              previousLabel={<i className="fas fa-angle-left"></i>}
              nextLabel={<i className="fas fa-angle-right"></i>}
              breakLabel={"..."}
              breakClassName={"pagination-break"}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          )}
        </div>
      </div>

      {this.state.pageCount > 0 && (
        <div className="grid-total">
          <h2>Total de registros: {this.state.length}</h2>
        </div>
      )}
    </div>

    <ModalPrincipal isOpen={this.state.isLoading}>
      <div className="modal-loading">
        <div className="modal-loading-content">
          <Loading />
        </div>
      </div>
    </ModalPrincipal>
  </div>
);
  }
}

export default Child;


